import { useQuery } from '@apollo/react-hooks';
import { RETRIEVE_BULK_QUOTATION } from '../graphql';
import React from 'react';

const useBulkQuotation = ({
  products,
  ...otherFactor
}, options) => {
  const stringifiedProducts = React.useMemo(() => JSON.stringify(products), [products]);
  const list = useQuery(RETRIEVE_BULK_QUOTATION, {
    variables: { ...otherFactor,
      products: stringifiedProducts
    },
    ...options,
    skip: !products.length
  });
  const quotations = React.useMemo(() => {
    if (!list.data) {
      return [];
    }

    return list.data.bulkQuotations;
  }, [list.data]);
  return [quotations, list];
};

export default useBulkQuotation;